import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils";

const baseUrl = "/api/dog/meritve/drob/dolocitevKakovostnegaRazreda";

export const createQualityClassification = createAsyncThunk(
  "quality-classification/create",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ApiClient.post(baseUrl, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const fetchQualityClassificationsPage = createAsyncThunk(
  "quality-classification/page",
  async ({ page, filter, sort }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(
        `${baseUrl}/page`,
        undefined,
        page,
        filter,
        sort,
        false
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const fetchQualityClassificationById = createAsyncThunk(
  "quality-classification/byId",
  async (id, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(`${baseUrl}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const qualityClassificationSlice = createSlice({
  name: "qualityClassification",
  initialState: {
    details: null,
    page: null,
    error: null,
    isLoading: false,
  },
  reducers: {
    resetQualityClassificationDetails(state) {
      state.details = null;
      state.error = null;
      state.isLoading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createQualityClassification.fulfilled, (state, action) => {
        state.isLoading = false;
        state.details = action.payload;
      })
      .addCase(createQualityClassification.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(createQualityClassification.pending, (state, _action) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchQualityClassificationsPage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.page = action.payload;
      })
      .addCase(fetchQualityClassificationsPage.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchQualityClassificationsPage.pending, (state, _action) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchQualityClassificationById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.details = action.payload;
      })
      .addCase(fetchQualityClassificationById.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchQualityClassificationById.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      });
  },
});

export const { resetQualityClassificationDetails } =
  qualityClassificationSlice.actions;
export default qualityClassificationSlice.reducer;
